const SUPPORTED_COUNTRIES = {
  ÅLAND_ISLANDS: 'AX',
  ALGERIA: 'DZ',
  ANDORRA: 'AD',
  ANGOLA: 'AO',
  ANGUILLA: 'AI',
  ANTIGUA_AND_BARBUDA: 'AG',
  ARGENTINA: 'AR',
  ARUBA: 'AW',
  AUSTRALIA: 'AU',
  AUSTRIA: 'AT',
  AZERBAIJAN: 'AZ',
  BAHAMAS: 'BS',
  BAHRAIN: 'BH',
  BANGLADESH: 'BD',
  BARBADOS: 'BB',
  BERMUDA: 'BM',
  BELIZE: 'BZ',
  BENIN: 'BJ',
  BHUTAN: 'BT',
  BOLIVIA: 'BO',
  BONAIRE: 'BQ',
  BOTSWANA: 'BW',
  BRAZIL: 'BR',
  BRITISH_INDIAN_OCEAN_TERRITORY: 'IO',
  BRITISH_VIRGIN_ISLANDS: 'VG',
  BRUNEI_DARUSSALAM: 'BN',
  BULGARIA: 'BG',
  BURKINA_FASO: 'BF',
  CAMBODIA: 'KH',
  CAMEROON: 'CM',
  CAPE_VERDE: 'CV',
  CANADA: 'CA',
  CAYMAN_ISLANDS: 'KY',
  CHAD: 'TD',
  CHILE: 'CL',
  CHINA: 'CN',
  CHRISTMAS_ISLAND: 'CX',
  COCOS_KEELING_ISLANDS: 'CC',
  COLOMBIA: 'CO',
  COMOROS: 'KM',
  CONGO: 'CG',
  COOK_ISLANDS: 'CK',
  COSTA_RICA: 'CR',
  CROATIA: 'HR',
  CURAÇAO: 'CW',
  CYPRUS: 'CY',
  CZECH_REPUBLIC: 'CZ',
  DENMARK: 'DK',
  DJIBOUTI: 'DJ',
  DOMINICA: 'DM',
  DOMINICAN_REPUBLIC: 'DO',
  ECUADOR: 'EC',
  EGYPT: 'EG',
  EL_SALVADOR: 'SV',
  EQUATORIAL_GUINEA: 'GQ',
  ERITREA: 'ER',
  ESTONIA: 'EE',
  ETHIOPIA: 'ET',
  FAROE_ISLANDS: 'FO',
  FIJI: 'FJ',
  FINLAND: 'FI',
  FRANCE: 'FR',
  FRENCH_POLYNESIA: 'PF',
  GABON: 'GA',
  GAMBIA: 'GM',
  GERMANY: 'DE',
  GHANA: 'GH',
  GIBRALTAR: 'GI',
  GREECE: 'GR',
  GRENADA: 'GD',
  GUAM: 'GU',
  GUERNSEY: 'GG',
  GUYANA: 'GY',
  HONDURAS: 'HN',
  HONG_KONG: 'HK',
  HUNGARY: 'HU',
  ICELAND: 'IS',
  INDIA: 'IN',
  INDONESIA: 'ID',
  IRELAND: 'IE',
  ISLE_OF_MAN: 'IM',
  ISRAEL: 'IL',
  ITALY: 'IT',
  IVORY_COAST: 'CI',
  JAMAICA: 'JM',
  JERSEY: 'JE',
  JORDAN: 'JO',
  KAZAKHSTAN: 'KZ',
  KENYA: 'KE',
  KIRIBATI: 'KI',
  KOSOVO: 'XK',
  KUWAIT: 'KW',
  KYRGYZSTAN: 'KG',
  LAO_PEOPLES_DEMOCRATIC_REPUBLIC: 'LA',
  LATVIA: 'LV',
  LESOTHO: 'LS',
  LIBERIA: 'LR',
  LIECHTENSTEIN: 'LI',
  LITHUANIA: 'LT',
  LUXEMBOURG: 'LU',
  MACAO: 'MO',
  MADAGASCAR: 'MG',
  MALAWI: 'MW',
  MALAYSIA: 'MY',
  MALDIVES: 'MV',
  MALI: 'ML',
  MALTA: 'MT',
  MAURITANIA: 'MR',
  MAURITIUS: 'MU',
  MEXICO: 'MX',
  MICRONESIA: 'FM',
  MONACO: 'MC',
  MONGOLIA: 'MN',
  MONTENEGRO: 'ME',
  MONTSERRAT: 'MS',
  MOROCCO: 'MA',
  MOZAMBIQUE: 'MZ',
  NAMIBIA: 'NA',
  NAURU: 'NR',
  NEPAL: 'NP',
  NETHERLANDS: 'NL',
  NEW_CALEDONIA: 'NC',
  NEW_ZEALAND: 'NZ',
  NICARAGUA: 'NI',
  NIGER: 'NE',
  NIGERIA: 'NG',
  NIUE: 'NU',
  NORFOLK_ISLAND: 'NF',
  NORTH_MACEDONIA: 'MK',
  NORWAY: 'NO',
  OMAN: 'OM',
  PAKISTAN: 'PK',
  PALAU: 'PW',
  PANAMA: 'PA',
  PAPUA_NEW_GUINEA: 'PG',
  PARAGUAY: 'PY',
  PERU: 'PE',
  PHILIPPINES: 'PH',
  PITCAIRN: 'PN',
  POLAND: 'PL',
  PORTUGAL: 'PT',
  PUERTO_RICO: 'PR',
  QATAR: 'QA',
  REPUBLIC_OF_THE_CONGO: 'CD',
  REPUBLIC_OF_KOREA: 'KR',
  REUNION: 'RE',
  ROMANIA: 'RO',
  RUSSIA: 'RU',
  RWANDA: 'RW',
  SAINT_BARTHELEMY: 'BL',
  SAINT_HELENA: 'SH',
  SAINT_KITTS_AND_NEVIS: 'KN',
  SAINT_LUCIA: 'LC',
  SAINT_MARTIN: 'MF',
  SAINT_PIERRE_AND_MIQUELON: 'PM',
  SAINT_VINCENT_AND_THE_GRENADINES: 'VC',
  SAMOA: 'WS',
  SAN_MARINO: 'SM',
  SAO_TOME_AND_PRINCIPE: 'ST',
  SAUDI_ARABIA: 'SA',
  SENEGAL: 'SN',
  SERBIA: 'RS',
  SEYCHELLES: 'SC',
  SIERRA_LEONE: 'SL',
  SINGAPORE: 'SG',
  SINT_MAARTEN: 'SX',
  SLOVAKIA: 'SK',
  SLOVENIA: 'SI',
  SOLOMON_ISLANDS: 'SB',
  SOMALIA: 'SO',
  SOUTH_AFRICA: 'ZA',
  SOUTH_SUDAN: 'SS',
  SRI_LANKA: 'LK',
  SUDAN: 'SD',
  SURINAME: 'SR',
  SVALBARD_AND_JAN_MAYEN: 'SJ',
  SWAZILAND: 'SZ',
  SWITZERLAND: 'CH',
  SWEDEN: 'SE',
  SYRIAN_ARAB_REPUBLIC: 'SY',
  TAIWAN: 'TW',
  TAJIKISTAN: 'TJ',
  TANZANIA: 'TZ',
  THAILAND: 'TH',
  TIMOR_LESTE: 'TL',
  TOGO: 'TG',
  TOKELAU: 'TK',
  TONGA: 'TO',
  TRINIDAD_AND_TOBAGO: 'TT',
  TUNISIA: 'TN',
  TURKEY: 'TR',
  TURKMENISTAN: 'TM',
  TURKS_AND_CAICOS_ISLANDS: 'TC',
  TUVALU: 'TV',
  UGANDA: 'UG',
  UKRAINE: 'UA',
  UNITED_ARAB_EMIRATES: 'AE',
  UK: 'GB',
  URUGUAY: 'UY',
  UZBEKISTAN: 'UZ',
  VANUATU: 'VU',
  VENEZUELA: 'VE',
  VIETNAM: 'VN',
  WALLIS_AND_FUTUNA: 'WF',
  WESTERN_SAHARA: 'EH',
  YEMEN: 'YE',
  ZAMBIA: 'ZM',
  ZIMBABWE: 'ZW',
} as const;

const LANGUAGES = {
  ENGLISH: 'en',
  CHINESE: 'zh',
  FRENCH: 'fr',
  GERMAN: 'de',
  ITALIAN: 'it',
  NORWEGIAN: 'no',
  POLISH: 'pl',
  SWEDISH: 'sv',
} as const;

export const REGIONS = {
  BERMUDA: 'bm',
  AUSTRALIA: 'au',
  AUSTRIA: 'at',
  BELGIUM: 'be',
  CANADA: 'ca',
  FRANCE: 'fr',
  GERMANY: 'de',
  IRELAND: 'ie',
  ITALY: 'it',
  NEW_ZEALAND: 'nz',
  NORWAY: 'no',
  POLAND: 'pl',
  SINGAPORE: 'sg',
  SWEDEN: 'se',
  UK: 'uk',
} as const;

type Region = (typeof REGIONS)[keyof typeof REGIONS];

const COUNTRIES_CONFIG: Record<string, Partial<Record<string, Region>>> = {
  [SUPPORTED_COUNTRIES.ÅLAND_ISLANDS]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.ALGERIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.ANDORRA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.ANGOLA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.ANGUILLA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.ANTIGUA_AND_BARBUDA]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.ARGENTINA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.ARUBA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.AUSTRALIA]: {
    [LANGUAGES.ENGLISH]: REGIONS.AUSTRALIA,
    [LANGUAGES.CHINESE]: REGIONS.AUSTRALIA,
  },
  [SUPPORTED_COUNTRIES.AUSTRIA]: { [LANGUAGES.GERMAN]: REGIONS.AUSTRIA },
  [SUPPORTED_COUNTRIES.AZERBAIJAN]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.BAHAMAS]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.BAHRAIN]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.BANGLADESH]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.BARBADOS]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.BERMUDA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.BELIZE]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.BENIN]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.BHUTAN]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.BOLIVIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.BONAIRE]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.BOTSWANA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.BRAZIL]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.BRITISH_INDIAN_OCEAN_TERRITORY]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.BRITISH_VIRGIN_ISLANDS]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.BRUNEI_DARUSSALAM]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.BULGARIA]: { [LANGUAGES.ENGLISH]: REGIONS.BELGIUM },
  [SUPPORTED_COUNTRIES.BURKINA_FASO]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.CAMBODIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.CAMEROON]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.CAPE_VERDE]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.CANADA]: {
    [LANGUAGES.ENGLISH]: REGIONS.CANADA,
    [LANGUAGES.CHINESE]: REGIONS.CANADA,
    [LANGUAGES.FRENCH]: REGIONS.CANADA,
  },
  [SUPPORTED_COUNTRIES.CAYMAN_ISLANDS]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.CHAD]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.CHILE]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.CHINA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.CHRISTMAS_ISLAND]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.COCOS_KEELING_ISLANDS]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.COLOMBIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.COMOROS]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.CONGO]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.COOK_ISLANDS]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.COSTA_RICA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.CROATIA]: { [LANGUAGES.ENGLISH]: REGIONS.BELGIUM },
  [SUPPORTED_COUNTRIES.CURAÇAO]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.CYPRUS]: { [LANGUAGES.ENGLISH]: REGIONS.BELGIUM },
  [SUPPORTED_COUNTRIES.CZECH_REPUBLIC]: {
    [LANGUAGES.ENGLISH]: REGIONS.BELGIUM,
  },
  [SUPPORTED_COUNTRIES.DENMARK]: { [LANGUAGES.ENGLISH]: REGIONS.BELGIUM },
  [SUPPORTED_COUNTRIES.DJIBOUTI]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.DOMINICA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.DOMINICAN_REPUBLIC]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.ECUADOR]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.EGYPT]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.EL_SALVADOR]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.EQUATORIAL_GUINEA]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.ERITREA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.ESTONIA]: { [LANGUAGES.ENGLISH]: REGIONS.BELGIUM },
  [SUPPORTED_COUNTRIES.ETHIOPIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.FAROE_ISLANDS]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.FIJI]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.FINLAND]: { [LANGUAGES.ENGLISH]: REGIONS.BELGIUM },
  [SUPPORTED_COUNTRIES.FRANCE]: { [LANGUAGES.FRENCH]: REGIONS.FRANCE },
  [SUPPORTED_COUNTRIES.FRENCH_POLYNESIA]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.GABON]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.GAMBIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.GERMANY]: { [LANGUAGES.GERMAN]: REGIONS.GERMANY },
  [SUPPORTED_COUNTRIES.GHANA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.GIBRALTAR]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.GREECE]: { [LANGUAGES.ENGLISH]: REGIONS.BELGIUM },
  [SUPPORTED_COUNTRIES.GRENADA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.GUAM]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.GUERNSEY]: { [LANGUAGES.ENGLISH]: REGIONS.UK },
  [SUPPORTED_COUNTRIES.GUYANA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.HONDURAS]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.HONG_KONG]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.HUNGARY]: { [LANGUAGES.ENGLISH]: REGIONS.BELGIUM },
  [SUPPORTED_COUNTRIES.ICELAND]: { [LANGUAGES.ENGLISH]: REGIONS.BELGIUM },
  [SUPPORTED_COUNTRIES.INDIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.INDONESIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.IRELAND]: { [LANGUAGES.ENGLISH]: REGIONS.IRELAND },
  [SUPPORTED_COUNTRIES.ISLE_OF_MAN]: { [LANGUAGES.ENGLISH]: REGIONS.UK },
  [SUPPORTED_COUNTRIES.ISRAEL]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.ITALY]: { [LANGUAGES.ITALIAN]: REGIONS.ITALY },
  [SUPPORTED_COUNTRIES.IVORY_COAST]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.JAMAICA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.JERSEY]: { [LANGUAGES.ENGLISH]: REGIONS.UK },
  [SUPPORTED_COUNTRIES.JORDAN]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.KAZAKHSTAN]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.KENYA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.KIRIBATI]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.KOSOVO]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.KUWAIT]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.KYRGYZSTAN]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.LAO_PEOPLES_DEMOCRATIC_REPUBLIC]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.LATVIA]: { [LANGUAGES.ENGLISH]: REGIONS.BELGIUM },
  [SUPPORTED_COUNTRIES.LESOTHO]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.LIBERIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.LIECHTENSTEIN]: { [LANGUAGES.ENGLISH]: REGIONS.BELGIUM },
  [SUPPORTED_COUNTRIES.LITHUANIA]: { [LANGUAGES.ENGLISH]: REGIONS.BELGIUM },
  [SUPPORTED_COUNTRIES.LUXEMBOURG]: {
    [LANGUAGES.FRENCH]: REGIONS.BELGIUM,
    [LANGUAGES.ENGLISH]: REGIONS.BELGIUM,
  },
  [SUPPORTED_COUNTRIES.MACAO]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.MADAGASCAR]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.MALAWI]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.MALAYSIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.MALDIVES]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.MALI]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.MALTA]: { [LANGUAGES.ENGLISH]: REGIONS.BELGIUM },
  [SUPPORTED_COUNTRIES.MAURITANIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.MAURITIUS]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.MEXICO]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.MICRONESIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.MONACO]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.MONGOLIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.MONTENEGRO]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.MONTSERRAT]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.MOROCCO]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.MOZAMBIQUE]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.NAMIBIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.NAURU]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.NEPAL]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.NETHERLANDS]: { [LANGUAGES.ENGLISH]: REGIONS.BELGIUM },
  [SUPPORTED_COUNTRIES.NEW_CALEDONIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.NEW_ZEALAND]: {
    [LANGUAGES.ENGLISH]: REGIONS.NEW_ZEALAND,
    [LANGUAGES.CHINESE]: REGIONS.NEW_ZEALAND,
  },
  [SUPPORTED_COUNTRIES.NICARAGUA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.NIGER]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.NIGERIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.NIUE]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.NORFOLK_ISLAND]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.NORTH_MACEDONIA]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.NORWAY]: { [LANGUAGES.NORWEGIAN]: REGIONS.NORWAY },
  [SUPPORTED_COUNTRIES.OMAN]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.PAKISTAN]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.PALAU]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.PANAMA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.PAPUA_NEW_GUINEA]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.PARAGUAY]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.PERU]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.PHILIPPINES]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.PITCAIRN]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.POLAND]: { [LANGUAGES.POLISH]: REGIONS.POLAND },
  [SUPPORTED_COUNTRIES.PORTUGAL]: { [LANGUAGES.ENGLISH]: REGIONS.BELGIUM },
  [SUPPORTED_COUNTRIES.PUERTO_RICO]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.QATAR]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.REPUBLIC_OF_THE_CONGO]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.REPUBLIC_OF_KOREA]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.REUNION]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.ROMANIA]: { [LANGUAGES.ENGLISH]: REGIONS.BELGIUM },
  [SUPPORTED_COUNTRIES.RUSSIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.RWANDA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.SAINT_BARTHELEMY]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.SAINT_HELENA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.SAINT_KITTS_AND_NEVIS]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.SAINT_LUCIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.SAINT_MARTIN]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.SAINT_PIERRE_AND_MIQUELON]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.SAINT_VINCENT_AND_THE_GRENADINES]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.SAMOA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.SAN_MARINO]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.SAO_TOME_AND_PRINCIPE]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.SAUDI_ARABIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.SENEGAL]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.SERBIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.SEYCHELLES]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.SIERRA_LEONE]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.SINGAPORE]: {
    [LANGUAGES.ENGLISH]: REGIONS.SINGAPORE,
    [LANGUAGES.CHINESE]: REGIONS.SINGAPORE,
  },
  [SUPPORTED_COUNTRIES.SINT_MAARTEN]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.SLOVAKIA]: { [LANGUAGES.ENGLISH]: REGIONS.BELGIUM },
  [SUPPORTED_COUNTRIES.SLOVENIA]: { [LANGUAGES.ENGLISH]: REGIONS.BELGIUM },
  [SUPPORTED_COUNTRIES.SOLOMON_ISLANDS]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.SOMALIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.SOUTH_AFRICA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.SOUTH_SUDAN]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.SRI_LANKA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.SUDAN]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.SURINAME]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.SVALBARD_AND_JAN_MAYEN]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.SWAZILAND]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.SWITZERLAND]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.SWEDEN]: { [LANGUAGES.SWEDISH]: REGIONS.SWEDEN },
  [SUPPORTED_COUNTRIES.SYRIAN_ARAB_REPUBLIC]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.TAIWAN]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.TAJIKISTAN]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.TANZANIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.THAILAND]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.TIMOR_LESTE]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.TOGO]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.TOKELAU]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.TONGA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.TRINIDAD_AND_TOBAGO]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.TUNISIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.TURKEY]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.TURKMENISTAN]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.TURKS_AND_CAICOS_ISLANDS]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.TUVALU]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.UGANDA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.UKRAINE]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.UNITED_ARAB_EMIRATES]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.UK]: { [LANGUAGES.ENGLISH]: REGIONS.UK },
  [SUPPORTED_COUNTRIES.URUGUAY]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.UZBEKISTAN]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.VANUATU]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.VENEZUELA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.VIETNAM]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.WALLIS_AND_FUTUNA]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.WESTERN_SAHARA]: {
    [LANGUAGES.ENGLISH]: REGIONS.BERMUDA,
  },
  [SUPPORTED_COUNTRIES.YEMEN]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.ZAMBIA]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
  [SUPPORTED_COUNTRIES.ZIMBABWE]: { [LANGUAGES.ENGLISH]: REGIONS.BERMUDA },
};

export function getRegionForCountry(countryCode: string, lang: string): Region {
  const countryMap = COUNTRIES_CONFIG[countryCode];
  if (countryMap) {
    // Falls back to any mapped region for countries only keyed by their native language (eg Germany's 'de').
    const region = countryMap[lang] ?? countryMap[LANGUAGES.ENGLISH] ?? Object.values(countryMap)[0];
    if (region) return region;
  }
  return REGIONS.BERMUDA;
}
